import { SubscriptionCenterSetPreferencesRoute } from './-subscription-center-routes';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/settings/subscription_center/topics/set_preferences',
)({
  component: SubscriptionCenterSetPreferencesRoute,
});
